import React from 'react';
import StaticTemplate from '../StaticTemplate';
import Issuers from './Issuers';
import Sponsors from './Sponsors';
import styles from '../Company/Company.scss';
import { getPageTitle } from '@/finsight/ui/common/helpers';
import URL from '@/finsight/Router/urlConstants';
import metaTags from '@/finsight/ui/common/metaTagsConstants';

const pages = [
  {
    name: 'Issuers',
    id: 'issuers-tab-id',
    path: URL.ISSUERS_LIST,
    component: Issuers,
    metaTitle: getPageTitle(metaTags.getCatalogIssuers().title),
    metaDescription: metaTags.getCatalogIssuers().description,
  },
  {
    name: 'Parents',
    id: 'sponsors-tab-id',
    path: URL.SPONSORS_LIST,
    component: Sponsors,
    metaTitle: getPageTitle(metaTags.getCatalogSponsors().title),
    metaDescription: metaTags.getCatalogSponsors().description,
  },
];

const Catalog = () => (
  <StaticTemplate
    isTabsLabelExists
    className={ styles.pageContainer }
    pages={ pages }
  />
);

export default Catalog;
